export default __webpack_public_path__ + "static/media/service.e0183a14.png";